import "./App.css";
import { useDispatch, useSelector } from "react-redux";
import { setAuthInitializing } from "./store/userSlice";
import { monitorAuthState } from "./store/userActions";
import Home from "./components/Home";
// import AboutUs from './components/AboutUs';
import TermsAndConditions from "./components/TermsAndConditions";
import PrivacyPolicy from "./components/PrivacyPolicy";
import FAQ from "./components/FAQ";
import Pricing from "./components/Pricing";
import ContactForm from "./components/ContactForm";
import ComparisonHub from "./components/compare/ComparisonHub";
import ComparisonPage from "./components/compare/ComparisonPage";
import NotFound from "./components/NotFound";
import DonorAccount from "./components/DonorAccount";
import DonorVerifyEmail from "./components/DonorVerifyEmail";
// import SuccessStories from './components/SuccessStories';
import Register from "./auth/Register";
import Login from "./auth/Login";
import VerifyEmail from "./auth/VerifyEmail";
import Onboarding from "./adminComponents/Onboarding";
import Banking from "./adminComponents/Banking";
import Dashboard from "./adminComponents/Dashboard";
import InvalidCampaignPage from "./adminComponents/InvalidCampaignPage";
import ManageSubscription from "./adminComponents/ManageSubscription";
import OrgProfile from "./adminComponents/OrgProfile";
// import ListRefunds from './adminComponents/ListRefunds';
import RefundDonation from "./adminComponents/RefundDonation";
import EmbedDonationForm from "./adminComponents/EmbedDonationForm";
import ListCampaigns from "./adminComponents/ListCampaigns";
import EditCampaign from "./adminComponents/EditCampaign";
import CreateCampaign from "./adminComponents/CreateCampaign";
import FundGroups from "./adminComponents/FundGroups";
import ListDonations from "./adminComponents/ListDonations";
import UpdateEmail from "./adminComponents/UpdateEmail";
import OrganizationSetup from "./adminComponents/OrganizationSetup";
import CreateWithdrawal from "./adminComponents/CreateWithdrawal";
import AllDonationDetails from "./moderateComponents/AllDonationDetails";
import DataEditor from "./moderateComponents/DataEditor";
import DonationDetail from "./adminComponents/DonationDetail";
import DonorHistory from "./adminComponents/DonorHistory";
import TipAdmin from "./adminComponents/TipAdmin";
import ListSubscriptions from "./adminComponents/ListSubscriptions";
import DonationFormStripe from "./adminComponents/DonationFormStripe";
import MyInfo from "./adminComponents/MyInfo";
import WithdrawalList from "./adminComponents/WithdrawalList";
import Settings from "./adminComponents/Settings";
import AcceptInvite from "./components/AcceptInvite";
import OrgSelectionPage from "./components/OrgSelectionPage";
import DonationThankYou from "./components/DonationThankYou";
import SystemAdminOrganizations from "./adminComponents/SystemAdminOrganizations";
import SystemAdminOrgDetail from "./adminComponents/SystemAdminOrgDetail";
import DefaultLayout from "./layout/DefaultLayout";
import AdminLayout from "./layout/AdminLayout";
import PrivateRoute from "./auth/PrivateRoute";
// import SessionValidator from './auth/SessionValidator';
import { ChakraProvider, Center, Box, Text, Spinner } from "@chakra-ui/react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import { useEffect } from "react";
import { HelmetProvider } from "react-helmet-async";
import theme from "./layout/theme";
import CookieConsent from "react-cookie-consent";
import ScrollToTop from "./components/ScrollToTop";
// import IdleTimeout from './auth/IdleTimeout';

function App() {
  const dispatch = useDispatch();
  const { authInitializing } = useSelector((state) => state.user);

  useEffect(() => {
    const unsubscribe = dispatch(monitorAuthState());

    return () => {
      unsubscribe();
      dispatch(setAuthInitializing(false));
    };
  }, [dispatch]);

  if (authInitializing) {
    return (
      <Center height="100vh">
        <Box textAlign="center">
          <Spinner size="xl" color="orange.500" />
          <Text mt={4} fontSize="lg">
            Loading...
          </Text>
        </Box>
      </Center>
    );
  }

  // Only show cookie consent on non-donation pages
  const ConsentGate = () => {
    const location = useLocation();
    const path = location.pathname || "";
    const hideConsent =
      path.startsWith("/donate/") || path.startsWith("/embed/donate/");
    if (hideConsent) return null;
    return (
      <CookieConsent
        location="bottom"
        buttonText="Accept"
        cookieName="purelygive_cookie_consent"
        style={{ background: "#222" }}
        buttonStyle={{ color: "#fff", background: "#FFA726", fontSize: "14px" }}
        expires={365}
      >
        We use cookies and similar technologies to enhance your experience. By
        clicking “Accept”, you consent to the use of cookies for analytics and
        essential site functions.{" "}
        <a
          href="/privacy-policy"
          style={{ color: "#FFA726", textDecoration: "underline" }}
        >
          Learn more
        </a>
        .
      </CookieConsent>
    );
  };

  return (
    <ChakraProvider theme={theme}>
      <HelmetProvider>
        <Router>
          <ScrollToTop />
          {/* <IdleTimeout /> */}
          {/* <SessionValidator /> */}
          <Routes>
            <Route element={<DefaultLayout />}>
              <Route path="/" element={<Home />} />
              <Route path="/frequently-asked-questions" element={<FAQ />} />
              <Route path="/pricing" element={<Pricing />} />
              <Route path="/contact" element={<ContactForm />} />
              <Route path="/compare" element={<ComparisonHub />} />
              <Route path="/compare/:competitorSlug" element={<ComparisonPage />} />
              <Route path="/login" element={<Login />} />
              <Route
                path="/terms-and-conditions"
                element={<TermsAndConditions />}
              />
              <Route path="/privacy-policy" element={<PrivacyPolicy />} />
              <Route path="/register" element={<Register />} />
              <Route path="/accept-invite" element={<AcceptInvite />} />
              <Route path="/donor/account" element={<DonorAccount />} />
              <Route
                path="/donor/verify-email"
                element={<DonorVerifyEmail />}
              />
              <Route path="/donate/thank-you" element={<DonationThankYou />} />
            </Route>
            <Route element={<AdminLayout />}>
              <Route element={<PrivateRoute />}>
                <Route
                  path="/select-organization"
                  element={<OrgSelectionPage />}
                />
                <Route
                  path="/system-admin/organizations"
                  element={<SystemAdminOrganizations />}
                />
                <Route
                  path="/system-admin/organizations/:orgId"
                  element={<SystemAdminOrgDetail />}
                />
              </Route>
              <Route element={<PrivateRoute />}>
                <Route path="/dashboard" element={<Dashboard />} />
                <Route path="/subscriptions" element={<ListSubscriptions />} />
                <Route path="/donations" element={<ListDonations />} />
                <Route path="/settings/bank" element={<Banking />} />
                {/* <Route path="/refunds" element={<ListRefunds />} /> */}
                <Route
                  path="/refunds/:donationId"
                  element={<RefundDonation />}
                />
                <Route
                  path="/donationsD/:donationId"
                  element={<AllDonationDetails />}
                />
                <Route
                  path="/donations/:donationId"
                  element={<DonationDetail />}
                />
                <Route path="/donors/:email" element={<DonorHistory />} />
                <Route path="/donation/create" element={<DonationFormStripe />} />
                <Route path="/campaigns" element={<ListCampaigns />} />
                <Route path="/campaigns/edit/:id" element={<EditCampaign />} />
                <Route path="/campaigns/create" element={<CreateCampaign />} />
                <Route path="/fund-groups" element={<FundGroups />} />
                <Route
                  path="/withdrawals/create"
                  element={<CreateWithdrawal />}
                />
                <Route path="/withdrawals" element={<WithdrawalList />} />
                <Route path="/info" element={<MyInfo />} />
                <Route path="/info/setup" element={<OrganizationSetup />} />
                <Route path="/info/email" element={<UpdateEmail />} />
                <Route path="/settings" element={<Settings />} />
                <Route path="/admin/view" element={<DataEditor />} />
                <Route path="/tips" element={<TipAdmin />} />
                <Route path="/bank" element={<Banking />} />
                <Route path="/bank/setup" element={<Onboarding />} />
              </Route>
            </Route>
            <Route path="/donate/:url" element={<DonationFormStripe />} />
            <Route path="/org/:org_id" element={<OrgProfile />} />
            <Route path="/invalid-campaign" element={<InvalidCampaignPage />} />
            <Route
              path="/embed/donate/:campaignId"
              element={<EmbedDonationForm />}
            />
            <Route
              path="/embed/donate/org/:orgSlug"
              element={<EmbedDonationForm />}
            />
            <Route
              path="/manage-subscription"
              element={<ManageSubscription />}
            />
            <Route path="/verify-email" element={<VerifyEmail />} />

            {/* 404 Route */}
            <Route path="*" element={<NotFound />} />
          </Routes>
          <ConsentGate />
        </Router>
      </HelmetProvider>
    </ChakraProvider>
  );
}

export default App;
